import clsx from 'clsx';
import type { ReactNode } from 'react';
import { ChevronLeft } from 'react-bootstrap-icons';

import { DataTestIds } from '@repo/frontend-shared';
import { SDSButton } from '@repo/sds/SDSButton';
import { SDSFlexbox, type SDSFlexboxGap } from '@repo/sds/SDSFlexbox';
import { SDSIcon } from '@repo/sds/SDSIcon';
import { SettingsCard } from '@repo/ui/components/elements/settings-card/settings-card';

import './mfa-settings-page.scss';

interface MfaSettingsPageProps {
  actions?: ReactNode;
  ariaLabel: string;
  backLabel: string;
  children: ReactNode;
  className?: string;
  dataTestId: string;
  fieldsGap?: SDSFlexboxGap;
  onBack: () => void;
}

export function MfaSettingsPage({
  actions,
  ariaLabel,
  backLabel,
  children,
  className,
  dataTestId,
  fieldsGap = 'text-x-large',
  onBack,
}: MfaSettingsPageProps) {
  return (
    <section aria-label={ariaLabel} className={clsx('MfaSettingsPage', className)} data-testid={dataTestId}>
      <SDSButton
        ariaLabel={backLabel}
        className="MfaSettingsPage__back"
        dataTestId={DataTestIds.COMMON.BACK_BUTTON}
        leftIcon={<SDSIcon icon={<ChevronLeft />} />}
        mode="ghost"
        onClick={onBack}
        size="large"
        text={backLabel}
      />
      <SettingsCard className="MfaSettingsPage__card" direction="column">
        <SDSFlexbox className="MfaSettingsPage__fields" direction="column" fullWidth gap={fieldsGap}>
          {children}
        </SDSFlexbox>
        {actions ? (
          <SDSFlexbox className="MfaSettingsPage__actions" fullWidth gap="button-medium" justifyContent="flex-end">
            {actions}
          </SDSFlexbox>
        ) : null}
      </SettingsCard>
    </section>
  );
}
